import { render, staticRenderFns } from "./ThePartnerList.vue?vue&type=template&id=41993532&scoped=true&"
import script from "./ThePartnerList.vue?vue&type=script&lang=ts&"
export * from "./ThePartnerList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41993532",
  null
  
)

export default component.exports